import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { ContractNFCS } from 'modules/contracts/contracts'
import { useSWR } from 'modules/network/hooks/useSwr'

export function useIsNFCSContractPaused() {
  const { chainId } = useWeb3()
  const { data, isLoading } = useSWR(`nfcs-paused-${chainId}`, async () => {
    const contract = ContractNFCS.connectRpc({ chainId })
    return contract.paused()
  })

  return { isNFCSPaused: data ?? false, isLoading }
}
